import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@chakra-ui/react';

import { analyticsIds } from '../../../../constants/analyticsIds';
import { ChakraSizes } from '../../../../constants/chakraSizes';
import { previewEmail } from '../../../../redux/modules/emails';
import { showModal } from '../../../../redux/modules/modal';
import PreviewModal from '../PreviewModal';

export default function PreviewCell({ row: { original: searchRecord } }) {
  const dispatch = useDispatch();

  const onClick = () => {
    const { job, insured, id: recordId } = searchRecord;
    const insuredId = insured.id;
    const jobId = job.id;
    dispatch(previewEmail(recordId, insuredId, jobId));
    dispatch(showModal(
      () => <PreviewModal recipientTitle="To" />,
      {
        title: 'Preview',
        actionRequired: false,
        size: ChakraSizes.ExtraLarge,
        maxW: 1440
      }
    ));
  };

  return (
    <Button
      data-analytics-id={analyticsIds.emailEditorPage.previewEmailButton}
      px={2}
      variant="textPrimary"
      onClick={onClick}
    >
      Preview
    </Button>
  );
}
